<template>
  <div>
    <CoverBg
      show-text
      :title="coverPageTitle"
      :text="coverPageContext"
    />
    <b-container
      class="main-container vacancies-item content-padding-t-b-100"
    >
      <Loading v-if="loading" />
      <div v-else>
        <VacancyHeading
          :title="formHeader.title"
          :date="formHeader.date"
        />
        <ApplyForm
          class="heading bg-none"
          :form-type="formType"
          :vacancy-id="id"
        />
      </div>
    </b-container>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import moment from 'moment';
import CoverBg from '@/components/CoverBg';
import VacancyHeading from '@/components/Vacancies/VacancyHeading';
import ApplyForm from '@/components/ApplyForm';
import Loading from '@/components/Loading';

export default {
  name: 'Apply',
  components: {
    Loading,
    ApplyForm,
    VacancyHeading,
    CoverBg,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapState({
      currentVacancy: (state) => state.vacancies.currentVacancy,
    }),
    id() {
      return Number(this.$route?.query?.id);
    },
    isVacancies() {
      return Number(this.$route?.query?.type) === 1;
    },
    coverPageTitle() {
      return this.isVacancies ? 'Vacancies' : 'SAS Trainings';
    },
    coverPageContext() {
      return this.isVacancies ? 'Our doors are open to new specialists who look for new opportunities and experience'
        : 'At STATECS training center we empower any beginner or an advanced programmer both with knowledge & motivation';
    },
    formType() {
      return this.isVacancies ? 'vacancies' : 'trainings';
    },
    formHeader() {
      return {
        title: this.isVacancies ? this.currentVacancy.title : 'SAS Base Training',
        date: this.isVacancies ? this.currentVacancy.date : moment().format('MM.DD.YYYY'),
      };
    },
  },
  async created() {
    if (this.isVacancies && !this.currentVacancy) {
      this.loading = true;
      await this.getVacancyById(this.id);
      this.loading = false;
    }
  },
  methods: {
    ...mapActions([
      'getVacancyById',
    ]),
  },
};
</script>
